import { FC, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import UserEntity from "../../../../domain/entities/UserEntity";
import { isLeft } from "fp-ts/lib/Either";
import di from "../../../../DependencyInjection";
import GetUserByIdUseCase, { GetUserByIdUseCaseName } from "../../../../domain/use_cases/user/GetUserByIdUseCase";
import KeyWordLocalization from "../../../utils/KeyWordLocalization";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent";
import NotFoundComponent from "../../../components/notFound/NotFoundComponent";
import routes from "../../../routes/Routes";
import LocalizationContext from "../../../providers/localization/LocalizationContext";
import LocalizationContextType from "../../../../domain/providers/localization/LocalizationContextType";

const DetailedUserPage: FC<{}> = () => {
    const { id } = useParams<{ id: string }>();
    const {i18n} = useContext(LocalizationContext) as LocalizationContextType;
    const [user, setUser] = useState<UserEntity | null | undefined>(undefined);
    const navigate = useNavigate();

    const _searchUser = async () => {
        if (id == undefined) return setUser(null);
        const response = await di.get<GetUserByIdUseCase>(GetUserByIdUseCaseName).call(id);
        if (isLeft(response)) return setUser(null);
        setUser(response.right);
    }

    const _handleEdit = () => navigate(routes.edit_user.relativePathWithParams({ id: id! }));

    useEffect(() => {
        _searchUser();
    }, [id]);

    return <div className="detailed_user_page">
        <LayoutComponent title={i18n(KeyWordLocalization.DetailedUserPageTitle)}>
            {user === undefined && <LoadingComponent />}
            {user === null && <NotFoundComponent />}
            {user && <>
                <div className="container py-5">
                    <div className="w-100 d-flex justify-content-between">
                        <h1>{i18n(KeyWordLocalization.DetailedUserPageTitle)}: {user.name}</h1>
                        {/* <ButtonComponent onClick={_handleEdit} icon={
                            <span className="material-symbols-outlined">edit</span>
                        } text={KeyWordLocalization.edit} /> */}
                    </div>
                    <div className="row">
                        <div className="col-md-12 my-3">
                            <div className="card">
                                <div className="card-body">
                                    <h3>
                                        {i18n(KeyWordLocalization.DetailedUserPageQuestions)}
                                    </h3>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>}
        </LayoutComponent>
    </div>
}

export default DetailedUserPage;